export const addTime = function (date, days = 0, hours = 0, minutes = 0) {
    const newDate = new Date(date); // Copy the original date

    // Add days
    newDate.setDate(newDate.getDate() + days);

    // Add hours
    newDate.setHours(newDate.getHours() + hours);

    // Add minutes
    newDate.setMinutes(newDate.getMinutes() + minutes);

    // Return the timestamp
    return newDate.getTime();
};

export function convertToMilliseconds(days = 0, hours = 0, minutes = 0) {
    console.log(days, hours, minutes, 'see the log here');
    // Define the number of milliseconds in one unit
    const millisecondsPerDay = 24 * 60 * 60 * 1000;
    const millisecondsPerHour = 60 * 60 * 1000;
    const millisecondsPerMinute = 60 * 1000;

    // Calculate total milliseconds
    const totalMilliseconds = days * millisecondsPerDay + hours * millisecondsPerHour + minutes * millisecondsPerMinute;
    console.log(Number(totalMilliseconds));
    return Number(totalMilliseconds);
}


export const dateAndYear =(dateInput)=>
{
    const isoDate = dateInput
const date = new Date(isoDate);

// Format options
const options = { year: 'numeric', month: 'long', day: 'numeric' };

// Convert to string like "22 August, 2025"
const formatted = date.toLocaleDateString('en-GB', options);

console.log(formatted); // "22 August 2025"
const [day, month, year] = formatted.split(" ");

return `${day} ${month}, ${year}`

}